<template>
  <div v-inview:once.enter="checkShowForm">
    <form @submit.prevent>
      <!-- 受講開始日 -->
      <div class="flex flex-col border-b border-dotted border-co-gray-300 pb-5 pt-4 md:flex-row md:gap-x-8">
        <label
          class="basis-full py-2 font-bold md:basis-4/12 md:text-right"
          for="entry_cohort_id"
        >
          受講開始日
          <TeCommonBadgeRequired class="ml-2" />
        </label>
        <div class="basis-full md:basis-8/12">
          <select
            id="entry_cohort_id"
            v-model="entryCohortSelected"
            class="select w-full border-2 border-co-gray-300"
            required
          >
            <option
              v-for="(option, index) in entryCohortOptions"
              :key="index"
              :value="option.value"
              :disabled="option.disabled"
            >
              {{ option.text }}
            </option>
          </select>
        </div>
      </div>
      <!-- プラン（受講期間） -->
      <div class="flex flex-col border-b border-dotted border-co-gray-300 pb-5 pt-4 md:flex-row md:gap-x-8">
        <label
          class="basis-full py-2 font-bold md:basis-4/12 md:text-right"
          for="entry_plan_id"
        >
          プラン（受講期間）
          <TeCommonBadgeRequired class="ml-2" />
        </label>
        <div class="flex basis-full flex-col items-baseline md:basis-8/12">
          <div
            v-if="showEntryStudent"
            id="entry-student"
            class="mb-2 flex gap-x-4"
          >
            <div
              v-for="(option, index) in entryStudentOptions"
              :key="index"
              class="form-control"
            >
              <label class="cursor-pointer">
                <input
                  v-model="entryStudentSelected"
                  type="radio"
                  :value="option.value"
                  :disabled="option.disabled"
                  name="entry-student"
                  required
                  class="radio"
                >
                <span class="ml-2">{{ option.text }}</span>
              </label>
            </div>
          </div>
          <!-- 割引対象者に表示させる -->
          <TeCommonBalloon
            v-show="entryDiscountTimeLimit && isDiscount && !entryCampaign"
            id="time-limit-form"
            class="co-left mb-5 rounded border-[#ff802b] bg-[#ff802b] tracking-[.15em] text-co-yellow-500"
          >
            割引特典
            表示価格より
            <span
              id="time-limit-form-discount-price"
              class="co-display-10 font-bold"
            >
              10,000</span>円引き
          </TeCommonBalloon>
          <select
            v-model="entryPlanSelected"
            class="select w-full border-2 border-co-gray-300"
            required
          >
            <option
              v-for="(option, index) in entryPlanOptions"
              :key="index"
              :value="option.value"
              :disabled="option.disabled"
            >
              {{ option.text }}
            </option>
          </select>
          <!-- キャンペーンのアラート -->
          <p
            v-if="promotion.isVisible()"
            class="co-display-13 mb-0 mt-2"
          >
            <FontAwesomeIcon
              :icon="faBullhorn"
              class="fa-fw mr-2 inline text-[1rem]"
              :class="promotion.isSetInPromotion(entryStudentSelected, entryPlanSelected, entryCohortSelected) ? 'text-co-info-500' : 'text-co-danger-500'"
            />
            {{ promotion.title }}の{{ promotion.isSetInPromotion(entryStudentSelected, entryPlanSelected, entryCohortSelected) ? '対象プラン' : '対象外' }}です
          </p>
        </div>
      </div>
      <!-- リスキリング補助制度 -->
      <TeSetApplyFormReskilling
        :pack-screen-name="packScreenName"
        :show-entry-reskilling-set="showEntryReskillingSet"
        :show-is-pro-benefit-system="showIsProBenefitSystem"
        :errors="errors"
        @change-entry-reskilling-set-selected="changeEntryReskillingSetSelected"
      />
      <!-- 氏名 -->
      <div class="flex flex-col border-b border-dotted border-co-gray-300 pb-5 pt-4 md:flex-row md:gap-x-8">
        <label
          class="basis-full py-2 font-bold md:basis-4/12 md:text-right"
          for="entry_last_name"
        >
          氏名
          <TeCommonBadgeRequired class="ml-2" />
        </label>
        <div class="basis-full md:basis-8/12">
          <div class="flex gap-x-4">
            <div class="basis-6/12">
              <input
                id="entry_last_name"
                v-model="lastName"
                class="input w-full border-2 border-co-gray-300"
                placeholder="煌木"
                type="text"
                required
                @change="applyChanges"
              >
              <span
                v-if="errors.last_name && errors.last_name.length !== 0"
                class="te-invalid-feedback inline-block"
              >
                {{ errors.last_name.join(', ') }}
              </span>
            </div>
            <div class="basis-6/12">
              <input
                v-model="firstName"
                class="input w-full border-2 border-co-gray-300"
                placeholder="太郎"
                type="text"
                required
                @change="applyChanges"
              >
              <span
                v-if="errors.first_name && errors.first_name.length !== 0"
                class="te-invalid-feedback inline-block"
              >
                {{ errors.first_name.join(', ') }}
              </span>
            </div>
          </div>
        </div>
      </div>
      <!-- 氏名（カナ） -->
      <div class="flex flex-col border-b border-dotted border-co-gray-300 pb-5 pt-4 md:flex-row md:gap-x-8">
        <label
          class="basis-full py-2 font-bold md:basis-4/12 md:text-right"
          for="entry_last_name_kana"
        >
          氏名（カナ）
          <TeCommonBadgeRequired class="ml-2" />
        </label>
        <div class="basis-full md:basis-8/12">
          <div class="flex gap-x-4">
            <div class="basis-6/12">
              <input
                id="entry_last_name_kana"
                v-model="lastNameKana"
                placeholder="キラメキ"
                type="text"
                required
                class="input w-full border-2 border-co-gray-300"
                @change="applyChanges"
              >
              <span
                v-if="errors.last_name_kana && errors.last_name_kana.length !== 0"
                class="te-invalid-feedback inline-block"
              >
                {{ errors.last_name_kana.join(', ') }}
              </span>
            </div>
            <div class="basis-6/12">
              <input
                v-model="firstNameKana"
                placeholder="タロウ"
                type="text"
                required
                class="input w-full border-2 border-co-gray-300"
                @change="applyChanges"
              >
              <span
                v-if="errors.first_name_kana && errors.first_name_kana.length !== 0"
                class="te-invalid-feedback inline-block"
              >
                {{ errors.first_name_kana.join(', ') }}
              </span>
            </div>
          </div>
        </div>
      </div>
      <!-- メールアドレス -->
      <div class="flex flex-col border-b border-dotted border-co-gray-300 pb-5 pt-4 md:flex-row md:gap-x-8">
        <label
          class="basis-full py-2 font-bold md:basis-4/12 md:text-right"
          for="entry_email"
        >
          メールアドレス
          <TeCommonBadgeRequired class="ml-2" />
        </label>
        <div class="basis-full md:basis-8/12">
          <input
            id="entry_email"
            v-model="email"
            placeholder="taro.kirameki@techacademy.jp"
            type="email"
            required
            class="input w-full border-2 border-co-gray-300"
            @change="applyChanges"
          >
          <span
            v-if="errors.email && errors.email.length !== 0"
            class="te-invalid-feedback inline-block"
          >
            {{ errors.email.join(', ') }}
          </span>
          <p class="co-display-13 mb-0 mt-2 text-co-gray-500">
            <span class="block">※できるだけPCのメールアドレスをご利用ください。</span>
            <span class="block">※携帯メールをご利用の際はドメイン指定受信の設定変更をお願いいたします。</span>
            <!-- 割引対象者に表示させる -->
            <span v-show="entryDiscountTimeLimit && isDiscount">※割引特典を利用する際には、無料相談でお申し込みされたメールアドレスをご入力ください。</span>
          </p>
        </div>
      </div>
      <!-- 電話番号 -->
      <div class="flex flex-col border-b border-dotted border-co-gray-300 pb-5 pt-4 md:flex-row md:gap-x-8">
        <label
          class="basis-full py-2 font-bold md:basis-4/12 md:text-right"
          for="entry_tel"
        >
          電話番号
          <TeCommonBadgeRequired class="ml-2" />
        </label>
        <div class="basis-full md:basis-8/12">
          <input
            id="entry_tel"
            v-model="tel"
            placeholder="09012345678（ハイフン不要）"
            type="tel"
            required
            class="input w-full border-2 border-co-gray-300"
            @change="applyChanges"
          >
          <span
            v-if="errors.tel && errors.tel.length !== 0"
            class="te-invalid-feedback inline-block"
          >
            {{ errors.tel.join(', ') }}
          </span>
        </div>
      </div>
      <!-- 生年月日 -->
      <div
        v-if="showBirthday"
        class="flex flex-col border-b border-dotted border-co-gray-300 pb-5 pt-4 md:flex-row md:gap-x-8"
      >
        <label
          class="basis-full py-2 font-bold md:basis-4/12 md:text-right"
          for="entry_birthday"
        >
          生年月日
          <TeCommonBadgeRequired class="ml-2" />
        </label>
        <div class="basis-full md:basis-8/12">
          <div class="flex gap-x-1">
            <select
              id="entry_birthday"
              v-model="birthdayYearSelected"
              class="select w-auto border-2 border-co-gray-300"
              required
              @change="applyChanges"
            >
              <option
                v-for="(option, index) in birthdayYearOptions"
                :key="index"
                :value="option.value"
              >
                {{ option.text }}
              </option>
            </select>
            <select
              v-model="birthdayMonthSelected"
              class="select w-auto border-2 border-co-gray-300"
              required
              @change="applyChanges"
            >
              <option
                v-for="(option, index) in birthdayMonthOptions"
                :key="index"
                :value="option.value"
              >
                {{ option.text }}
              </option>
            </select>
            <select
              v-model="birthdayDaySelected"
              class="select w-auto border-2 border-co-gray-300"
              required
              @change="applyChanges"
            >
              <option
                v-for="(option, index) in birthdayDayOptions"
                :key="index"
                :value="option.value"
              >
                {{ option.text }}
              </option>
            </select>
            <span
              v-if="errors.birthday && errors.birthday.length !== 0"
              class="te-invalid-feedback inline-block"
            >
              {{ errors.birthday.join(', ') }}
            </span>
          </div>
          <!-- 転職保証アラート -->
          <div
            v-if="packScreenName === 'webengineer-jobchange' && (entryUserAge > 34 || entryUserAge < 20)"
            class="pt-5"
          >
            <div class="inline-block w-auto list-disc rounded border-[#fff3cd] bg-[#fff3cd] p-5 text-left text-[#856404]">
              ※ 転職保証は受講開始日時点で20歳以上34歳以下の方が対象です。お申し込みいただくことは可能ですが、保証対象外である旨ご了承ください。
            </div>
          </div>
          <div
            v-if="entryStudentSelected === '1' && showEntryStudent && entryUserAge < 18"
            id="js-parental-consent-validation"
            class="pt-5"
          >
            <label
              for="parental_consent"
              class="label cursor-pointer justify-start gap-x-2"
            >
              <input
                id="parental_consent"
                v-model="parentalStatus"
                type="checkbox"
                class="checkbox checkbox-xs"
              >
              <span class="co-display-13 label-text">親権者の了承を得ている</span>
            </label>
          </div>
        </div>
      </div>
      <!-- 備考 -->
      <div class="flex flex-col border-b border-dotted border-co-gray-300 pb-5 pt-4 md:flex-row md:gap-x-8">
        <label
          class="basis-full py-2 font-bold md:basis-4/12 md:text-right"
          for="entry_remarks"
        >
          備考
          <TeCommonBadgeOptional class="ml-2" />
        </label>
        <div class="basis-full md:basis-8/12">
          <input
            id="entry_remarks"
            v-model="remarks"
            type="text"
            class="input w-full border-2 border-co-gray-300"
            @change="applyChanges"
          >
          <p class="co-display-13 mt-1">
            <span
              v-show="!!entryCampaign && isDiscount"
              class="block text-co-gray-500"
            >※ 無料相談の割引特典をご利用される方はこちらにキャンペーンコードをご入力ください。</span>
            ご質問いただいてもご返信差し上げることができません。<br>
            お申し込み後にお問い合わせフォームからご質問ください。
          </p>
        </div>
      </div>
      <!-- 申し込み内容を確認するボタン -->
      <div class="flex flex-col justify-end pb-5 pt-4 md:flex-row">
        <div class="basis-full md:ml-auto md:basis-8/12 md:pl-6">
          <div
            v-if="entryStudentSelected === '1' && entryUserAge < 18 && parentalStatus === false"
            id="validation-msg"
            class="pb-5 text-co-danger-500"
          >
            生年月日の欄にある「親権者の了承を得ている」にチェックが必要です
          </div>
          <span
            v-if="Object.keys(errors).length !== 0"
            class="te-invalid-feedback inline-block py-2"
          >
            入力いただいた情報に誤りまたは不足があるようです。
          </span>
          <span
            v-if="applicationErrors.length !== 0"
            class="te-invalid-feedback inline-block py-2"
          >
            {{ applicationErrors[0] }}
          </span>
          <!-- 申し込み内容を確認するボタン -->
          <button
            :disabled="isEntryDisabled"
            class="co-btn-submit-stretch"
            @click="onSubmit(false)"
          >
            申し込み内容を確認する
          </button>
        </div>
      </div>
    </form>

    <!-- お申し込み内容の確認モーダル -->
    <client-only>
      <Teleport to="body">
        <dialog
          ref="applyModal"
          class="modal"
        >
          <div class="modal-box">
            <!-- 右上の閉じるボタン -->
            <button
              class="btn btn-circle btn-ghost btn-sm absolute right-2 top-2"
              @click="closeModal"
            >
              ✕
            </button>
            <!-- モーダルのコンテンツ -->
            <div class="te-modal-body">
              <TeCourseConfirmForm
                v-if="confirmationItems"
                :last-name="lastName"
                :first-name="firstName"
                :last-name-kana="lastNameKana"
                :first-name-kana="firstNameKana"
                :tel="tel"
                :birthday="getBirthday()"
                :course="pack"
                :cohort="entryCohort"
                :entry-plan-title="entryPlanTitle"
                :remarks="remarks"
                :email="email"
                :closes-before-day="closesBeforeDay"
                :promotion="isInPromotion ? currentPromotion.attributes.title : null"
                :is-pro-benefit-system="showIsProBenefitSystem ? isProBenefitSystem : null"
                :is-reskilling="showReskilling ? isReskilling : null"
                :confirmation-items="confirmationItems"
                :course-name-path="packScreenName"
                :show-entry-reskilling="showEntryReskillingSet"
              />
              <!-- モーダルフッター -->
              <div class="modal-action absolute inset-x-0 bottom-0 mt-0 flex w-full justify-between border-t border-co-gray-200 p-4 backdrop-blur md:justify-around">
                <button
                  class="co-btn-tertiary"
                  @click="closeModal"
                >
                  修正する
                </button>
                <button
                  class="co-btn-submit !w-auto !px-3 !py-1 !text-[1rem]"
                  @click="onSubmit(true)"
                >
                  申し込みを確定する
                </button>
              </div>
            </div>
          </div>
          <!-- モーダルの外側をクリックしたら閉じる -->
          <button
            class="modal-backdrop"
            @click="closeModal"
          >
            close
          </button>
        </dialog>
      </Teleport>
    </client-only>
  </div>
</template>

<script lang="ts">
import {
  postPackEntry,
  getPromotionCohorts,
  getEntryDiscountTimeLimit,
} from '~/utility/fetchAPI'
import { yearOptions, monthOptions, dayOptions } from '~/utility/utility'
import validatePackApplyForm from '~/utility/validation/validatePackApplyForm'
import validatePackReskillingApplyForm from '~/utility/validation/validatePackReskillingApplyForm'
import { AdItems } from '~/utility/constants/ad_items'

import TeCommonBadgeRequired from '~/components/Te/TeCommon/Badge/TeCommonBadgeRequired/TeCommonBadgeRequired.vue'
import TeCommonBadgeOptional from '~/components/Te/TeCommon/Badge/TeCommonBadgeOptional/TeCommonBadgeOptional.vue'
import TeCommonBalloon from '~/components/Te/TeCommon/Balloon/TeCommonBalloon/TeCommonBalloon.vue'
import TeSetApplyFormReskilling from '~/components/Te/TeSet/TeSetApplyFormReskilling.vue'
import TeCourseConfirmForm from '~/components/Te/TeCourse/TeCourseConfirmForm.vue'

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faBullhorn } from '@awesome.me/kit-65d95819ce/icons/classic/solid'

interface TextValue {
  value: string
  text: string
  disabled?: boolean
}

interface Data {
  email: string
  lastName: string
  lastNameKana: string
  firstName: string
  firstNameKana: string
  entryCohortSelected: string
  tel: string
  birthday: string
  remarks: string
  entryCohorts: any
  entryStudentSelected: string
  entryPlanSelected: string
  birthdayYearSelected: string
  birthdayYearOptions: TextValue[]
  birthdayMonthSelected: string
  birthdayMonthOptions: TextValue[]
  birthdayDaySelected: string
  birthdayDayOptions: TextValue[]
  parentalStatus: Boolean
  errors: any
  applicationErrors: string[]
  promotionCohorts: number[]
  entryDiscountTimeLimit: null | any
  confirmationItems: object | null
  entryReskillingSelected: string
  isProBenefitSystem: boolean
  isReskilling: boolean
}

interface Methods {
  onSubmit: (isPersist: boolean) => void
  checkShowForm: () => void
  getBirthday: () => Date | null
  selectedPlanOption: () => TextValue
  changeEntryReskillingSetSelected: (selected: string) => void
}

interface Computed {
  entryCohortOptions: TextValue[]
  entryPlanOptions: TextValue[]
  entryStudentOptions: TextValue[]
  isInPromotion: boolean
  isDiscount: boolean
  entryUserAge: number
  showEntryStudent: boolean
  showBirthday: boolean
  showIsProBenefitSystem: boolean
  isEntryDisabled: boolean
  closesBeforeDay: Date
  entryPlan: object
  entryPlanTitle: string
  showEntryReskillingSet: boolean
  showReskilling: boolean
  promotionTitle: string
  entryCohort: object
}

interface Props {
  pack: any
  packPlans: any
  currentPromotion: any
  packScreenName: string | null
}

const options = {
  async setup(props: Props) {
    const { $criteoEvent: criteoEvent }  = useNuxtApp()
    const isShowForm = ref(false)

    // モーダルの開閉制御
    const applyModal = ref<HTMLDialogElement | null>(null)

    const showModal = () => {
      if (applyModal.value) {
        applyModal.value.showModal();
      }
    };

    const closeModal = () => {
      if (applyModal.value) {
        applyModal.value.close();
      }
    };

    const promotion = usePromotion('set', props.packScreenName as string)

    return {
      applyModal,
      showModal,
      closeModal,
      criteoEvent,
      isShowForm,
      faBullhorn,
      promotion,
    }
  },
  props: {
    pack: {
      default: null,
    },
    packPlans: {
      default: () => [],
    },
    currentPromotion: {
      default: null,
    },
    packScreenName: {
      type: String,
      default: null,
    },
    entryCampaign: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      lastName: '',
      firstName: '',
      lastNameKana: '',
      firstNameKana: '',
      email: '',
      tel: '',
      birthday: '',
      remarks: '',
      entryCohortSelected: '',
      entryCohorts: [],
      entryStudentSelected: '0',
      entryPlanSelected: '',
      birthdayYearSelected: '1991',
      birthdayYearOptions: yearOptions,
      birthdayMonthSelected: '5',
      birthdayMonthOptions: monthOptions,
      birthdayDaySelected: '27',
      birthdayDayOptions: dayOptions,
      parentalStatus: false,
      errors: {},
      applicationErrors: [],
      promotionCohorts: [],
      entryDiscountTimeLimit: null,
      confirmationItems: null,
      entryReskillingSelected: '', // リスキリング補助制度、ラジオボタンの初期状態を空にする
      isProBenefitSystem: false,
      isReskilling: false,
    }
  },
  mounted() {
    getPromotionCohorts(this.$api, this.packScreenName).then((response) => {
      this.promotionCohorts = response.data
    })
    getEntryDiscountTimeLimit(this.$api).then((response) => {
      this.entryDiscountTimeLimit = response.entry_discount_time_limit
    })
  },
  watch: {
    // 学生・社会人の切り替え時にプラン選択をリセット
    entryStudentSelected() {
      this.entryPlanSelected = ''
    },
  },
  computed: {
    entryCohortOptions() {
      if (this.packPlans && this.packPlans.length !== 0) {
        const selectedPlan = this.selectedPlanOption()
        const options: TextValue[] = this.packPlans.map((plan: any) => {
          return {
            text: plan.attributes.display_title_for_entry,
            value: plan.id,
            disabled:
              plan.attributes.display_title_for_entry.includes('【先割】') &&
              selectedPlan.text.includes('8週間'),
          }
        })
        // 初期値設定
        if (this.entryCohortSelected === '') {
          this.entryCohortSelected = options[0].value
        }
        return options
      } else {
        return [{ value: '0', text: '読み込み中' }]
      }
    },
    entryPlanOptions() {
      const selectedCohort = this.packPlans
        ? this.packPlans.find((plan: any) => {
            return Number(plan.id) === Number(this.entryCohortSelected)
          })
        : null
      let options: TextValue[]
      if (selectedCohort) {
        if (this.entryStudentSelected === '0') {
          options = selectedCohort.attributes.collection_for_social_plans.map(
            (plan: any) => {
              return {
                value: `${plan.id}`,
                text: plan.title,
                disabled:
                  plan.title.includes('8週間') &&
                  selectedCohort.attributes.display_title_for_entry.includes(
                    '【先割】'
                  ),
              }
            }
          )
        } else {
          options = selectedCohort.attributes.collection_for_student_plans.map(
            (plan: any) => {
              return {
                value: `${plan.id}`,
                text: plan.title,
                disabled:
                  plan.title.includes('8週間') &&
                  selectedCohort.attributes.display_title_for_entry.includes(
                    '【先割】'
                  ),
              }
            }
          )
        }

        // 初期値設定
        if (this.entryPlanSelected === '') {
          this.entryPlanSelected = options[0]?.value
        }
        return options
      } else {
        return [{ value: '0', text: '読み込み中' }]
      }
    },
    entryStudentOptions() {
      return [
        { text: '社会人', value: '0' },
        { text: '学生', value: '1', disabled: this.isProBenefitSystem },
      ]
    },
    isInPromotion() {
      if (
        this.pack &&
        this.packPlans &&
        this.currentPromotion &&
        this.entryStudentSelected &&
        this.entryPlanSelected
      ) {
        const packName = this.pack.attributes.track_screen_name

        // 対象のパックでない場合はプロモーションではない
        if (!this.currentPromotion.attributes.screen_names.includes(packName)) {
          return false
        }

        // Cohort == Pack
        const selectedCohort = this.packPlans.find((pack: any) => {
          return Number(pack.id) === Number(this.entryCohortSelected)
        })
        const plans = [
          ...selectedCohort.attributes.collection_for_social_plans,
          ...selectedCohort.attributes.collection_for_student_plans,
        ]
        const selectedPlan = plans.find((plan: any) => {
          return Number(plan.id) === Number(this.entryPlanSelected)
        })

        const planWeeks = selectedPlan.weeks.toString()
        if (this.currentPromotion.attributes.weeks.includes(planWeeks)) {
          if (
            this.promotionCohorts.includes(Number(this.entryCohortSelected))
          ) {
            return true
          } else {
            return false
          }
        } else {
          return false
        }
      } else {
        return false
      }
    },
    isDiscount() {
      const sakiwariCohorts = this.pack && this.pack.attributes.sakiwari_packs
      if (sakiwariCohorts) {
        return !sakiwariCohorts.find(
          (cohort: any) => cohort.id === Number(this.entryCohortSelected)
        )
      } else {
        return true
      }
    },
    entryUserAge() {
      // 誕生年月日
      const birthday = new Date(
        Number(this.birthdayYearSelected),
        Number(this.birthdayMonthSelected) - 1,
        Number(this.birthdayDaySelected)
      )
      const today = new Date()

      // 今年の誕生日
      const thisYearBirthday = new Date(
        today.getFullYear(),
        birthday.getMonth(),
        birthday.getDate()
      )
      let age = today.getFullYear() - birthday.getFullYear()
      age = today < thisYearBirthday ? age - 1 : age
      return age
    },
    showEntryStudent() {
      if (this.entryCohortSelected) {
        const selectedCohort = this.packPlans
          ? this.packPlans.find((plan: any) => {
              return Number(plan.id) === Number(this.entryCohortSelected)
            })
          : null
        if (
          selectedCohort.attributes.collection_for_student_plans.length === 0
        ) {
          return false
        }
      }
      return ![
        // 学生のラジオボタンを表示しない
        'iphone-android-set',
        'unity-iphone-set',
        'unity-android-set',
        'webdesign-freelance-set',
        'python-prompt-set',
        'first-sidejob-webdesign-set',
        'webengineer-jobchange',
        'web-practice-set',
      ].includes(this.packScreenName as string)
    },
    showBirthday() {
      return (
        this.entryStudentSelected === '1' ||
        this.packScreenName === 'webengineer-jobchange'
      )
    },
    showIsProBenefitSystem() {
      return (
        [
          'python-ai-set',
          'python-datascience-set',
          'python-ai-datascience-set',
          'jobchange-bootcamp',
        ].includes(this.packScreenName as string) &&
        this.entryStudentSelected === '0'
      )
    },
    isEntryDisabled() {
      return (
        this.entryUserAge < 18 &&
        this.showEntryStudent &&
        this.parentalStatus === false &&
        this.packScreenName !== 'webengineer-jobchange'
      )
    },
    closesBeforeDay() {
      const date = new Date(this.pack.attributes.closes_at)
      date.setDate(date.getDate() - 1)
      return date
    },
    entryPlan() {
      const plan = Object.values(this.entryPlanOptions).find((plan: any) => {
        return Number(plan.value) === Number(this.entryPlanSelected)
      }) as any

      return plan
    },
    entryPlanTitle() {
      let entryStudent = ''

      if (this.showEntryStudent && this.entryStudentSelected) {
        entryStudent = Object.values(this.entryStudentOptions).find(
          (option: any) => {
            return Number(option.value) === Number(this.entryStudentSelected)
          }
        )!.text
      }

      let planTitle = ''
      if (this.entryPlanSelected) {
        planTitle = this.entryPlanOptions!.find((option: any) => {
          return Number(option.value) === Number(this.entryPlanSelected)
        })!.text.split('（')[0]
      }

      return [entryStudent, planTitle].join(' ')
    },
    entryCohort() {
      const sakiwariCohorts =
        this.pack && this.pack.attributes.sakiwari_packs
          ? this.pack.attributes.sakiwari_packs
          : []
      return this.packPlans
        .concat(sakiwariCohorts)
        .find(
          (pack: any) => Number(pack.id) === Number(this.entryCohortSelected)
        )
    },
    // リスキリング補助制度：通常コース
    showEntryReskillingSet() {
      return [
        'webengineer-jobchange',
        'python-ai-set',
        'python-datascience-set',
      ].includes(this.packScreenName as string)
    },
    showReskilling() {
      return this.showEntryReskillingSet
    },
    promotionTitle() {
      return this.currentPromotion ? this.currentPromotion.attributes.title : ''
    },
  },
  methods: {
    onSubmit(isPersist = false) {
      this.errors = {}
      this.applicationErrors = []
      const body: any = {
        pack_entry: {
          pack_id: this.entryCohortSelected,
          pack_plan_id: this.entryPlanSelected,
          student: this.entryStudentSelected,
          email: this.email,
          last_name: this.lastName,
          last_name_kana: this.lastNameKana,
          first_name: this.firstName,
          first_name_kana: this.firstNameKana,
          reskilling: this.entryReskillingSelected, // validation用
          is_pro_benefit_system: this.isProBenefitSystem,
          is_reskilling: this.isReskilling,
          tel: this.tel,
          remarks: this.remarks,
          marketing_params: this.$marketingParams.get(),
        },
      }
      if (this.entryStudentSelected === '1') {
        body.pack_entry.birthday = `${this.birthdayYearSelected}-${this.birthdayMonthSelected}-${this.birthdayDaySelected}`
      }

      let validateForm = validatePackApplyForm
      // リスキリングの時はバリデーションを変える
      if (this.showReskilling) {
        validateForm = validatePackReskillingApplyForm
      }

      validateForm(body)
        .then(() => {
          delete body.pack_entry.reskilling
          postPackEntry(
            this.$api,
            this.pack.attributes.track_screen_name,
            body,
            isPersist
          )
            .then((data) => {
              if (isPersist) {
                this.$marketingParams.remove()
                window.location.href = `/packs/${this.pack.attributes.track_screen_name}/entries/completed`
              } else {
                this.confirmationItems = data
                this.applyModal.showModal()
              }
            })
            .catch((errors: any) => {
              this.applicationErrors = errors?.response?.data?.errors
            })
        })
        .catch((errors: any) => {
          this.errors = errors
        })
    },
    checkShowForm() {
      const adItems: any = AdItems
      this.waitCourseIntervalId = setInterval(() => {
        if (this.pack?.id) {
          this.criteoEvent(String(adItems[this.packScreenName as string].item_id), 185000)
          clearInterval(this.waitCourseIntervalId)
        }
      }, 5000)
    },
    getBirthday() {
      let date = null

      if (this.entryStudentSelected === '1') {
        date = new Date(
          Number(this.birthdayYearSelected),
          Number(this.birthdayMonthSelected) - 1,
          Number(this.birthdayDaySelected)
        )
      }

      return date
    },
    selectedPlanOption() {
      const options = this.entryPlanOptions || []
      const entryPlanOption = options.find((option: any) => {
        return option.value === this.entryPlanSelected
      })
      return entryPlanOption || { value: '0', text: '読み込み中' }
    },
    changeEntryReskillingSetSelected(selected: string) {
      this.entryReskillingSelected = selected
      this.isReskilling = selected === '0'
    },
  },
  components: {
    TeCommonBadgeRequired,
    TeCommonBadgeOptional,
    TeCommonBalloon,
    TeSetApplyFormReskilling,
    TeCourseConfirmForm,
    FontAwesomeIcon,
  },
}

export default defineNuxtComponent(options)
</script>

<style scoped>
.te-invalid-feedback {
  width: 100%;
  margin-top: .25rem;
  font-size: .875em;
  color: #dc3545;
}
</style>
